export default __webpack_public_path__ + "static/media/heroimage.e00abca3.svg";